/**
 * Build a hierarchical tree from a flat array of orgs returned by the
 * /overview/orgs endpoint. Each org has { orgId, parentId, ... }.
 *
 * Orgs whose parentId is absent or points outside the assigned set become roots.
 */
export const buildOrgTree = (flatOrgs = []) => {
  const nodeMap = new Map();

  for (const org of flatOrgs) {
    nodeMap.set(org.orgId, { ...org, id: org.orgId, children: [] });
  }

  const roots = [];

  for (const node of nodeMap.values()) {
    const parent = node.parentId && nodeMap.get(node.parentId);
    if (parent) {
      parent.children.push(node);
    } else {
      roots.push(node);
    }
  }

  // Sort children alphabetically at each level.
  const sortChildren = (nodes) => {
    nodes.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
    for (const n of nodes) sortChildren(n.children);
  };
  sortChildren(roots);

  return roots;
};
